import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import commonRootReducer from '../redux/commonRootReducer';
import keystoneMyOpenRootReducer from '../redux/keystoneMyOpenRootReducer';

const initialState = {
    authorizedApps: [],
    activeUser: null,
    authenticatedUser: null,
    locationTitle: '',
};

const store = createStore(
    combineReducers({...commonRootReducer, ...keystoneMyOpenRootReducer}),
    initialState,
    compose(
        applyMiddleware(thunk)
    ),
);

export default store;
